export const createError = e => ({
  err: e?.error || e?.stack || 'Ошибка',
  status: e?.response?.status || 0,
  msg:
    e?.response?.data ||
    e?.response?.data?.message ||
    e?.response?.data?.error ||
    e?.response?.request?.responseText ||
    e?.response?.data?.description ||
    'Что то пошло не так. Обратитесь к администратору',
  path: e?.request?.responseURL || ''
})
